import { render, staticRenderFns } from "./Cities.html?vue&type=template&id=564e747e&"
import script from "./Cities.js?vue&type=script&lang=js&"
export * from "./Cities.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports